<template>
  <div
    v-if="contentIsValid"
    class="highlight-element highlight-description-container"
  >
    <div
      class="highlight-description"
      v-html="content"
    />
  </div>
</template>

<script>
export default {
  name: 'sp-feature-card-content-description',
  props: {
    content: {
      type: String, // html really
      required: false,
      default: ''
    }
  },
  computed: {
    contentIsValid() {
      return this.content !== ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../scss/variables";

.highlight-description {
  font-size: var(--cta-description-text);
}
</style>
